/**
 * biin-stats.js — Animación de los contadores de biin.lat (homepage).
 *
 * Escucha el evento de scroll y, cuando el contenedor
 * `.biin-stats-container` entra en viewport, anima los números con
 * los datos que se inyectaron vía `wp_localize_script` en el objeto global `biinStats`.
 *
 * NOTA: este archivo es la fuente. La versión minificada (producida por
 * `npm run build:js`) se emite en `assets/js/biin-stats.min.js` y la
 * que se encola desde `functions.php` del child theme.
 */

(function () {
    'use strict';

    // El script se encola en todo el sitio, pero sólo debe animar
    // los contadores en la home (donde Avada añade `class="home"` al <body>).
    if (!document.body || (!document.body.classList.contains('home') && !document.body.classList.contains('page-id-2558'))) {
        return;
    }

    function isInViewport(el) {
        if (!el) return false;
        var rect = el.getBoundingClientRect();
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
    }

    function animateNumber(elementId, endValue, duration) {
        var element = document.getElementById(elementId);
        if (!element) return;

        var startValue = 0;
        var increment = (endValue - startValue) / (duration / 16);
        var currentValue = startValue;

        var timer = setInterval(function () {
            currentValue += increment;
            if (currentValue >= endValue) {
                currentValue = endValue;
                clearInterval(timer);
            }
            element.textContent = Math.floor(currentValue).toLocaleString();
        }, 16);
    }

    function fire() {
        var container = document.querySelector('[data-biin-stats]');
        if (!container) return;

        if (!isInViewport(container)) return;

        window.removeEventListener('scroll', fire);
        window.removeEventListener('touchmove', fire);

        if (typeof biinStats === 'undefined') {
            console.warn('[biin] biinStats no está definido — ¿wp_localize_script falló?');
            return;
        }

        animateNumber('biin-num-boletas',     parseInt(biinStats.boletas)     || 0, 3000);
        animateNumber('biin-num-contratos',   parseInt(biinStats.contratos)   || 0, 3000);
        animateNumber('biin-num-prestadores', parseInt(biinStats.prestadores) || 0, 3000);

        var stats = [
            { id: 'biin-stat-boletas',     delay: '1s'   },
            { id: 'biin-stat-contratos',   delay: '0.5s' },
            { id: 'biin-stat-prestadores', delay: '0s'   }
        ];

        stats.forEach(function (s) {
            var el = document.getElementById(s.id);
            if (el) {
                el.style.animation = 'biinFadeIn 0.5s ' + s.delay + ' forwards';
            }
        });
    }

    document.addEventListener('DOMContentLoaded', function () {
        window.addEventListener('scroll', fire);
        window.addEventListener('touchmove', fire, { passive: true });
        fire();
    });
})();